import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { Box, Button, Text } from '@node-space/ui-components'
import { SidePanelImageIcon } from '../SidePanelImageIcon'
import { BottomContent, DownloadLink } from '../types'

interface Heading {
  iconUrls: string[]
  primaryLabel: string | ReactNode
  secondaryLabel: string | ReactNode
}
export interface SidePanelHeaderTemplateTwoProps {
  heading?: Heading
  bottomContent?: BottomContent
  downloadLink?: DownloadLink
  children?: ReactNode
  isDividerDisplayed?: boolean
}

export const SidePanelHeaderTemplateTwo = ({
  heading,
  bottomContent,
  downloadLink,
  children,
  isDividerDisplayed = true,
}: SidePanelHeaderTemplateTwoProps) => {
  const hasBottomContent =
    bottomContent?.leftLabel ||
    bottomContent?.leftDescription ||
    bottomContent?.rightLabel ||
    bottomContent?.rightDescription
  const hasLabel =
    heading?.primaryLabel &&
    typeof heading?.primaryLabel === 'string' &&
    heading?.secondaryLabel &&
    typeof heading?.secondaryLabel === 'string'

  return (
    <>
      <Box id="header-template-two" flex align="center" gap={12} className="relative">
        {heading?.iconUrls && heading?.iconUrls?.length === 1 && (
          <SidePanelImageIcon
            width={32}
            height={32}
            hasBackgroundColor={false}
            src={heading?.iconUrls?.[0]}
          />
        )}

        {heading?.iconUrls && heading?.iconUrls?.length === 2 && (
          <Box flex>
            <SidePanelImageIcon
              width={32}
              height={32}
              hasBackgroundColor={false}
              src={heading?.iconUrls?.[0]}
            />
            <Box className="absolute ml-6">
              <SidePanelImageIcon
                width={32}
                height={32}
                hasBackgroundColor={false}
                src={heading?.iconUrls?.[1]}
              />
            </Box>
          </Box>
        )}

        {hasLabel ? (
          <Box
            flexCol
            className={clsx({
              'ml-5': heading?.iconUrls?.length === 2,
              relative: heading?.iconUrls?.length !== 2,
            })}
          >
            <Text variant="body-text" className="text-500">
              {heading?.secondaryLabel}
            </Text>
            <Text variant="heading-3" className="text-900">
              {heading?.primaryLabel}
            </Text>
          </Box>
        ) : (
          <Box
            className={clsx({
              'ml-5': heading?.iconUrls?.length === 2,
              relative: heading?.iconUrls?.length !== 2,
            })}
          >
            {heading?.secondaryLabel}
            {heading?.primaryLabel}
          </Box>
        )}
      </Box>

      {isDividerDisplayed && <Box divideBox="top" className="my-4" />}

      {hasBottomContent && (
        <Box gapX={16} className="md:flex lg:flex">
          {bottomContent?.leftLabel && bottomContent?.leftDescription && (
            <Box className="md:w-1/2">
              <Text variant="body-text" color="prominent" className="mb-1">
                {bottomContent?.leftLabel}
              </Text>
              {bottomContent?.leftDescription}
            </Box>
          )}
          {bottomContent?.rightLabel && bottomContent?.rightDescription && (
            <Box className="pt-3 sm:pt-0 md:w-1/2">
              <Text variant="body-text" color="prominent" className="mb-1">
                {bottomContent?.rightLabel}
              </Text>
              {bottomContent?.rightDescription}
            </Box>
          )}
        </Box>
      )}

      {downloadLink?.onClick && downloadLink?.label && (
        <Box flex align="center" paddingT={12} gap={4}>
          {downloadLink?.icon}
          <Button variant="ghost" color="" noPadding onClick={downloadLink?.onClick}>
            {downloadLink?.label}
          </Button>
        </Box>
      )}

      {children && (
        <Box flex paddingT={12}>
          {children}
        </Box>
      )}
    </>
  )
}
